import { createSlice } from "@reduxjs/toolkit";

// The country option of the funnel (countries, postal code digits, map image).
// Loaded on the zip code screen and cleared after the lead is saved.
const countryOptionSlice = createSlice({
  name: "countryOption",
  initialState: {
    countryOption: null
  },
  reducers: {
    setCountryOption: (state, action) => {
      state.countryOption = action.payload;
    },
    clearCountryOption: (state) => {
      state.countryOption = null;
    }
  }
});

export const { setCountryOption, clearCountryOption } =
  countryOptionSlice.actions;
export default countryOptionSlice.reducer;
